var _defineProperty = require("/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable no-console */
var Sentry = require('@sentry/gatsby');

exports.onClientEntry = function (_, pluginParams) {
  var isIntialized = isSentryInitialized();
  var areOptionsDefined = areSentryOptionsDefined(pluginParams);

  if (isIntialized) {
    if (areOptionsDefined) {
      console.warn('Sentry Logger [Warn]: The SDK was initialized in the Sentry config file, but options were found in the Gatsby config. ' + 'These have been ignored. Merge them to the Sentry config if you want to use them.\n' + 'Learn more about the Gatsby SDK in https://docs.sentry.io/platforms/javascript/guides/gatsby/.');
    }

    return;
  }

  if (!areOptionsDefined) {
    console.error('Sentry Logger [Error]: No config for the Gatsby SDK was found.\n' + 'Learn how to configure it in https://docs.sentry.io/platforms/javascript/guides/gatsby/.');
    return;
  }

  Sentry.init(_objectSpread({
    // eslint-disable-next-line no-undef
    dsn: __SENTRY_DSN__
  }, pluginParams));
};

function isSentryInitialized() {
  // Although `window` should exist because we're in the browser (where this script
  // is run), and `__SENTRY__.hub` is created when importing the Gatsby SDK, double
  // check that in case something weird happens.
  return !!(window && window.__SENTRY__ && window.__SENTRY__.hub && window.__SENTRY__.hub.getClient());
}

function areSentryOptionsDefined(params) {
  if (params == undefined) return false; // Even if there aren't any options, there's a `plugins` property defined as an empty array

  if (Object.keys(params).length == 1 && Array.isArray(params.plugins) && params.plugins.length == 0) {
    return false;
  }

  return true;
}